export const m = {
	new_txt1: 'You are not logged in. You can only view 3 records',
	new_txt2: 'Sign in now',
	new_txt3:'No imformation temporary',
	new_txt4:'nothing',
	
	order_state1:'To be quoted',
	order_state_txt1:'Please wait patiently for the salesman to contact you for quotation',
	
	order_state2:'To be paid',
	order_state_txt2:'Please contact the salesman for payment',
	
	order_state3:'To be shipped',
	order_state_txt3:'Please wait patiently for the warehouse to deliver the goods',
	
	order_state4:'Goods to be received',
	order_state_txt4:'Please wait patiently for the warehouse to deliver the goods',
	
	order_state5:'Cancelled',
	
	order_state6:'Received goods',
	order_state_txt6:'Thank you for your support',
	
	
	zw_txt1:'There is no receiving address. Go and add it',
	zw_txt2:'No news from me',
	zw_txt3:'No help center',
	zw_txt4:'No order for me',
	
	
	shoping_txt1:'commodity',
	
	wl_tit:'Logistics List',
	wl_txt1:'Delivery time',
	wl_txt2:'Delivery method',
	wl_txt3:'Shipment No',
	wl_txt4:'Goods shipped',
	wl_txt5:'Detail',
	wl_txt6:'Goods shipped',
	
	
	
	title: 'Taiqiu123 | Billiards Wholesale Platform | Billiards Equipment | Billiard Cues | Pool Table | Billiard Accessories',
	is_en: 'true',
	home_012: 'Please register first',
	home_011: "privilege grant failed",
	home_01: "Search",
	home_02: "Brand",
	home_03: "Product",
	home_033: "Instructions",
	home_04: "Contact Us",
	home_05: "list",
	home_06: "Journalism",
	home_07: "product",
	home_08: "contact",
	home_09: "We",
	home_10: "Please enter product keywords",
	home_11: "View Details",
	home_12: "address",
	home_13: "Telephone",
	home_14: "Mail Box",
	home_15: "Full Name",
	home_16: "Content",
	home_17: "Release Time",
	home_18: "Submit",
	home_19: "Submitted successfully!",
	userhome_01: 'Unpaid orders',
	userhome_02: 'Amount paid',
	userhome_03: 'Customer service contact information',
	userhome_04: 'Trend Chart Of Orders',
	userhome_05: 'Trend chart of order amount (paid)',
	userinfo_01: "Head Portrait",
	userinfo_02: "Modify Avatar",
	userinfo_03: "nickname",
	userinfo_04: "corporate name",
	userinfo_05: "Company tax number",
	userinfo_06: "Edit Materials",
	userinfo_07: "Your account approval was rejected. Please check the reason for modification",
	userinfo_077: "Your account is under review, please wait patiently",
	userinfo_08: "View reason",
	userinfo_09: "Submit for review",
	userinfo_10: "Data cannot be modified during audit",
	userinfo_11: "business license of a corporation",
	userinfo_12: "Upload pictures",
	userinfo_13: "User Identity",
	userinfo_133: "Login method",
	userinfo_134: "Mailbox",
	userinfo_135: "Phone",
	userinfo_14: "User identity tag",
	userinfo_15: "Preservation",
	userinfo_16: "Please enter a nickname",
	userinfo_17: "Please enter email",
	userinfo_18: "Please enter the phone number",
	userinfo_19: "Please enter the company name",
	userinfo_20: "Please enter the company tax number",
	userinfo_21: "personal",
	userinfo_22: "enterprise",
	userinfo_23: "Bind a Third Party",
	userinfo_24: "Binding",
	userinfo_245: "Bound",
	userinfo_25: "Reason for rejection",
	userinfo_26: "good",
	userinfo_27: "Please enter your mobile number",
	userinfo_28: "Please upload the company business license",
	userinfo_29: "Successfully modified",
	MallCenter_01: 'Mall Center',
	MallCenter_02: 'Class',
	MallCenter_03: 'Brand',
	MallCenter_04: '',
	MallCenter_05: '   In Total',
	MallCenter_06: 'Please enter product keywords',
	MallCenter_07: 'Serial number',
	MallCenter_08: 'Commodity Map',
	MallCenter_09: 'Commodity Name',
	MallCenter_10: 'Commodity Type',
	MallCenter_11: 'Brand',
	MallCenter_12: 'Model',
	MallCenter_13: 'Unit Price (RMB)',
	MallCenter_14: 'Unit Price (USD)',
	MallCenter_15: 'Operation',
	MallCenter_16: 'Open',
	MallCenter_17: 'Put Away',
	MallCenter_18: 'Order Now',
	MallCenter_19: 'Product details',
	MallCenter_20: 'Whole',
	MallCenter_21: 'Please enter product keywords',
	MallCenter_22: 'Please login first',
	MallCenter_23: 'Please select at least one item to order',
	MallCenter_24: 'Current commodity inventory is insufficient',
	MallCenter_25: 'Home Page',
	MallCenter_26: 'Search Result',
	Myorder_01: 'My Order',
	Myorder_02: 'To be quoted',
	Myorder_03: 'Pending payment',
	Myorder_04: 'To be shipped',
	Myorder_05: 'To be received',
	Myorder_06: 'Received goods',
	Myorder_07: 'download',
	Myorder_08: 'Order No',
	Myorder_09: 'Commodity Name',
	Myorder_10: 'Purchase Specifications',
	Myorder_11: 'Purchase Quantity',
	Myorder_12: 'Order Time',
	Myorder_122: 'Cancel Time',
	Myorder_1222: 'Quotation Time',
	Myorder_12222: 'Delivery Time',
	Myorder_13: 'Order Status',
	Myorder_14: 'To be quoted',
	Myorder_15: 'Pending payment',
	Myorder_16: 'To be shipped',
	Myorder_17: 'To be received',
	Myorder_18: 'To be cancelled',
	Myorder_19: 'To be completed',
	address_01: 'My Shipping Address',
	address_02: 'Add a new shipping address',
	address_03: 'edit',
	address_04: 'delete',
	address_05: 'Consignee Name',
	address_06: 'Consignee telephone',
	address_07: 'Detailed address',
	address_08: 'Return',
	address_09: 'Please enter the name of the consignee',
	address_10: 'Please enter the phone number of the consignee',
	address_11: 'Please enter the detailed address',
	address_12: 'Tips',
	address_13: 'Are you sure to delete this address',
	address_14: 'confirm deletion',
	address_15: 'Create shipping address',
	address_16: 'Confirm new',
	address_17: 'Switch the default address successfully',
	address_18: 'Edit shipping address',
	address_19: 'Confirm',
	address_20: 'Please enter your name',
	address_21: 'Please enter your mobile number',
	address_22: 'Please enter the detailed address',
	address_23: 'Created successfully!',
	address_24: 'Edit succeeded!',
	address_25: 'Deletion succeeded!',
	RetrievePWD_01: 'Retrieve Password',
	RetrievePWD_02: 'Set new password',
	RetrievePWD_03: 'Set password again',
	RetrievePWD_04: 'Get it back now',
	RetrievePWD_05: 'Please enter a new password',
	RetrievePWD_06: 'Please enter the new password again',
	RetrievePWD_07: 'Congratulations on successfully retrieving your password',
	RetrievePWD_08: 'The two passwords are inconsistent',
	index_01: 'Home Page',
	index_02: 'Personal Information',
	index_03: 'Mall Center',
	index_04: 'My Order',
	index_05: 'Receiving Address',
	index_06: 'Retrieve Password',
	index_07: 'My Message',
	index_08: 'Help Center',
	index_09: 'Log Out',
	index_10: 'Are you sure to log out?',
	index_11: 'Confirm exit',
	index_12: 'Return to the home page',
	index_13: 'Login / registration',
	PlaceOrder_01: 'Return to the previous page',
	PlaceOrder_02: 'Confirm Demand Order',
	PlaceOrder_03: 'Order Notes',
	PlaceOrder_04: 'Please enter order comments',
	PlaceOrder_05: 'Total Order Price',
	PlaceOrder_06: 'consignee',
	PlaceOrder_066: 'No receiving address information temporarily',
	PlaceOrder_07: 'Specification Top',
	PlaceOrder_08: 'Quantity',
	PlaceOrder_09: 'Total Price (RMB)',
	PlaceOrder_10: 'Total Price (USD)',
	PlaceOrder_099: 'Unit Price (RMB)',
	PlaceOrder_100: 'Unit Price (USD)',
	PlaceOrder_11: 'Select shipping address',
	PlaceOrder_12: 'Please Select',
	Submit_01: 'Order Submitted Successfully',
	Submit_02: 'Please wait patiently for the salesman to contact you',
	Submit_03: 'Continue To Buy',
	Submit_04: 'View Order Details',
	order_info_01: 'Confirm receipt',
	order_info_02: 'Cancellation Of Order',
	order_info_03: 'download',
	order_info_04: 'Order Information',
	order_info_05: 'Cost (RMB)',
	order_info_06: 'Cost (USD)',
	order_info_07: 'Please confirm the receipt after receiving the goods and checking them',
	order_info_08: 'Cancel order',
	order_info_09: 'Confirm Cancellation',
	order_info_10: 'Goods received successfully',
	order_info_11: 'Order cancellation succeeded',
	login_01: 'Login',
	login_02: 'No account yet',
	login_03: 'Register Now',
	login_04: 'E-Mail',
	login_044: 'Phone number',
	login_05: 'Password',
	login_06: 'Have you forgotten your password?',
	login_07: 'with',
	login_08: 'continue',
	login_09: 'Please enter email account',
	login_10: 'Please input a password',
	login_11: 'By logging in, you agree',
	login_12: 'Terms of use',
	login_13: 'Willing to receive email and latest information from Haff amusement, and have read it',
	login_14: 'Privacy policy',
	login_15: 'Login successful, about to jump to the home page',
	register_01: 'Register',
	register_02: 'There is already an account',
	register_03: 'Bind Email',
	register_04: 'Verification Code',
	register_05: 'Enter the password again',
	register_06: 'Get code',
	register_07: 'Upload business license',
	register_08: 'Please enter the binding email address',
	register_08: 'Please enter your phone number',
	register_09: 'Enter verification code',
	register_10: 'Please enter the password again',
	register_11: 'company',
	register_12: 'Verification code has been sent to your email',
	registerSuccess_01: 'Congratulations',
	registerSuccess_02: 'success',
	registerSuccess_03: 'Go login',
	RetrievePwd_01: 'Please enter email address',
	RetrievePwd_02: 'Please enter the bound email account'
}
